import { reduxForm } from "redux-form";
import { connect } from "react-redux";
import RatingForm from "./RatingForm";
import { createClassroomRating } from "../../processes/ratingsProcesses";

function mapStateToProps(state) {
  return {
    initialValues: {},
    ratingableId: state.currentClassroomId,
  };
}

export default connect(mapStateToProps)(
  reduxForm({
    form: "classroomRatingForm",
    onSubmit: createClassroomRating,
  })(RatingForm)
);
